<template>
  <layout>

    <div>
      <div class="flex items-center">
        <img src="@/assets/images/mv-logo.svg" alt="My Vends 2.0" class="w-12 h-12 mr-2">
        <h2 class="text-4xl tracking-widest">MyVends</h2>
      </div>
      <div v-if="isSuccess" class="mt-4 text-lg max-w text-green-600">
        Your account has been confirmed. You can login with your account
        <button
          @click="navigateToLogin"
          :class="{ 'cursor-not-allowed': isLoading }"
          class="mt-4 w-full flex justify-center items-center py-2 px-4 border border-transparent font-semibold text-base rounded-md text-white bg-big-stone hover:bg-blumine focus:outline-none focus:ring-2 focus:ring-sail focus:shadow-outline-sail active:bg-blumine transition duration-150 ease-in-out">
          Go to Login
        </button>
      </div>
      <p v-else class="mt-2 text-lg max-w text-gray-500">
        Confirm registration. Verification Code has been send to your email.
      </p>
    </div>

    <div v-if="!isSuccess" class="mt-8">
      <div class="mt-6">
        <form class="space-y-6" @submit.prevent="verify">
          <error v-if="errorMsg">{{ errorMsg }}</error>
          <text-input v-model="code" type="text" name="code" label="Verification Code" placeholder="Verification Code" :is-loading="isLoading" />

          <div class="flex items-center justify-between">
            <div class="text-sm leading-5">
              <button type="button" @click="resendVerificationCode" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                I didn't recieve verification code
              </button>
            </div>
          </div>

          <div>
            <span class="block w-full rounded-md shadow-sm">
              <button
                type="submit"
                :class="{ 'cursor-not-allowed': isLoading }"
                :disabled="isLoading"
                class="w-full flex justify-center items-center py-2 px-4 border border-transparent font-semibold text-base rounded-md text-white bg-big-stone hover:bg-blumine focus:outline-none focus:ring-2 focus:ring-sail focus:shadow-outline-sail active:bg-blumine transition duration-150 ease-in-out">
                <loading v-show="isLoading" class="w-5 h-5 mr-3" /> Verify registration
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </layout>
</template>

<script>
import { Auth } from '@/services/auth.js'
import Layout from '@/layouts/Auth.vue'
import Loading from '@/components/icons/Loading.vue'
import TextInput from '@/components/form/Text.vue'
import Error from '@/components/form/Error.vue'

export default {
  components: {
    Layout,
    Loading,
    TextInput,
    Error
  },

  data: () => ({
    code: '',
    email: '',
    errorMsg: '',
    isLoading: false,
    isSuccess: false,
  }),

  created() {
    const email = localStorage.getItem('email')
    if (!email) this.$router.push({ name: 'Register' })

    this.email = email

    if (localStorage.getItem('resend-code')) {
      this.resendVerificationCode()
      localStorage.removeItem('resend-code')
    }
  },

  methods: {
    navigateToLogin() {
      this.$router.push({ name: 'Login'})
    },
    async resendVerificationCode() {
      this.isLoading = true

      try {
        await Auth.resendVerificationCode(this.email)
        // localStorage.removeItem('email')
        // this.navigateToLogin()
      } catch (error) {
        this.errorMsg = error.message
      }
      this.isLoading = false
    },
    async verify() {
      this.isLoading = true

      try {
        await Auth.confirm(this.email, this.code)
        localStorage.removeItem('email')
        this.isSuccess = true
      } catch (error) {
        this.errorMsg = error.message
      }
      this.isLoading = false
    }
  }
}
</script>
